module.exports = __webpack_public_path__ + "img/PL08141.a440e69e.png";